import { DocumentsTable } from '@/components/Templates/Documents';

const Documents = () => {
	return <DocumentsTable />;
};

export default Documents;
